import { useState, useEffect, useContext } from 'react';

import { TranslateContext } from '@/context/TranslateContext';

interface TitleUpdate {
  (newTitle: string): void;
}

const useDocumentTitle = (initialTitle: string, prefix: string = 'GO2'): TitleUpdate => {
  const [title, setTitle] = useState(buildTitle(initialTitle));
  const { locale } = useContext(TranslateContext);

  function buildTitle(str: string): string {
    let _newTitle = str;
    if (prefix) {
      _newTitle += ` | ${prefix}`;
    }
    return _newTitle;
  }

  const updateTitle: TitleUpdate = (newTitle) => {
    const _newTitle = buildTitle(newTitle);
    setTitle(_newTitle);
  };

  useEffect(() => {
    document.title = buildTitle(initialTitle);
  }, [locale, initialTitle, title]);

  return updateTitle;
};

export default useDocumentTitle;
